import {
  VisibleArea,
  getVisibleSelectionAreas,
} from '../../../helpers/selectionHelper';
import { UseSheetTheme } from '../../../hooks/useSheetTheme';
import { ReturnTypeofSheetSectionsSelector } from '../../../selectors/sheetUiSelector';
import { Area, SelectionOperationType } from '../../../types';
import { isEqualAreas, isSingleCell } from '../../../utils/area/area';
import React from 'react';
import { UseCellSelection } from '../../../hooks/useCellSelection';
import AreaSelectionBorder from './AreaSelectionBorder';

interface AreaSelectionProps
  extends Omit<ReturnTypeofSheetSectionsSelector, 'selections'>,
    Pick<
      UseSheetTheme,
      | 'isRtl'
      | 'selectionFill'
      | 'extendCircleBorderColor'
      | 'extendSelectionBorderColor'
    >,
    Pick<UseCellSelection, 'handleSelectionInteraction'> {
  sheetId: string;
  stageWidth: number;
  area: Area;
  isActive: boolean;
  zIndex: number;
  currentOp?: SelectionOperationType;
  tempOp?: SelectionOperationType;
}
const AreaSelection: React.FC<AreaSelectionProps> = ({
  sheetId,
  selecting,
  area,
  stageWidth,
  isActive,
  isRtl,
  selectionFill,
  zIndex,
  extendCircleBorderColor,
  extendSelectionBorderColor,
  currentOp,
  tempOp,
  handleSelectionInteraction,
  ...props
}) => {
  const isExtendOpExist = tempOp === SelectionOperationType.Extend;
  const borderVisible =
    !isActive ||
    (isActive && !selecting && !tempOp) ||
    (isActive && isExtendOpExist);
  const isMoveOp =
    currentOp === SelectionOperationType.ColMove ||
    currentOp === SelectionOperationType.RowMove;

  // console.log("area", area)

  const areas = getVisibleSelectionAreas(props, area, stageWidth, isRtl);
  const singleCell = isActive && isEqualAreas(area, props.activeCellArea); //isSingleCell(area);

  const renderAreaBackground = ({ x, y, width, height }: VisibleArea) => (
    <div
      style={{
        position: 'absolute',
        backgroundColor: isMoveOp
          ? selectionFill
          : singleCell
          ? 'transparent'
          : selectionFill,
        opacity: 0.1,
        pointerEvents: 'none',
        border: 'none',
        left: `${x}px`,
        top: `${y}px`,
        width: `${width}px`,
        height: `${height}px`,
      }}
    />
  );

  const renderBorder = (visibleArea: VisibleArea, isLast: boolean) => (
    <AreaSelectionBorder
      {...visibleArea}
      isLast={isLast}
      isActive={isActive}
      currentOp={currentOp}
      zIndex={zIndex}
      extendSelectionBorderColor={extendSelectionBorderColor}
      extendCircleBorderColor={extendCircleBorderColor}
      selectionFill={selectionFill}
      isRtl={isRtl}
      selecting={selecting}
      handleSelectionInteraction={handleSelectionInteraction}
    />
  );

  const renderVisbleAreas = () =>
    areas.map((visibleArea, index: number) => {
      const { x, y, width, height } = visibleArea;
      if (width === 0 || height === 0) {
        return null;
      }

      return (
        <div key={`${x}-${y}-${width}-${height}`} style={{ zIndex: zIndex }}>
          {(!currentOp || isMoveOp) && renderAreaBackground(visibleArea)}
          {borderVisible &&
            renderBorder(visibleArea, index === areas.length - 1)}
        </div>
      );
    });

  return <>{renderVisbleAreas()}</>;
};

export default AreaSelection;
